import { observer } from "mobx-react-lite";
import MockRenderCrash from "../mocks/MockRenderCrash";
import featuresStore from "../stores/features/featuresStore";

const preprodCN = "w-full bg-surface-warning text-ink-warning p-2 text-center print:hidden";

const PreprodInfo = () => {
   const { mockScenarios, newOrderFlowEnabled } = featuresStore;
   return (
      <div className={preprodCN}>
         Du er nå i test-miljøet. Ny ordreflyt {newOrderFlowEnabled ? "AKTIVERT" : "IKKE aktivert"}{" "}
         {mockScenarios.length > 0 && <span>Aktivt mock scenario: {mockScenarios.join(", ")}</span>}
         {mockScenarios.includes("errorRenderCrash") && <MockRenderCrash />}
      </div>
   );
};

export default observer(PreprodInfo);
